/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IntegrationStatusFromJSON, IntegrationStatusToJSON, } from './IntegrationStatus';
/**
 * Check if a given object implements the SystemStatus interface.
 */
export function instanceOfSystemStatus(value) {
    if (!('environment' in value) || value['environment'] === undefined)
        return false;
    if (!('version' in value) || value['version'] === undefined)
        return false;
    if (!('integrations' in value) || value['integrations'] === undefined)
        return false;
    return true;
}
export function SystemStatusFromJSON(json) {
    return SystemStatusFromJSONTyped(json, false);
}
export function SystemStatusFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'environment': json['environment'],
        'version': json['version'],
        'integrations': (json['integrations'].map(IntegrationStatusFromJSON)),
    };
}
export function SystemStatusToJSON(json) {
    return SystemStatusToJSONTyped(json, false);
}
export function SystemStatusToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'environment': value['environment'],
        'version': value['version'],
        'integrations': (value['integrations'].map(IntegrationStatusToJSON)),
    };
}
